import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import Button from 'grommet/components/Button';
import Modal from 'react-modal';
import Spinning from 'grommet/components/icons/Spinning';
import classes from './CancelAttendanceOrClass.module.scss';
import Close from 'grommet/components/icons/base/Close';
import { returnCancelClassDetails } from '../../../shared/classFunctions';
import withUser from '../../../store/hoc/withUser';
import { useMutation } from 'react-query';
import { delayFetchFunctions, cancelAttendance, cancelClass } from '../../../apiFunctions/apiFunctions';
import CustomToast from '../../../components/CustomToast/CustomToast';
import { returnErrorFromResponse } from '../../../shared/utility';

const CancelAttendanceOrClass = ({ type, selectedClass, user, attendance, cancelType = 'upcoming' }) => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [toast, setToast] = useState(null);
  const cancelClassDetails = returnCancelClassDetails(selectedClass, user.role);

  const mutateCancelAttendance = useMutation(() => cancelAttendance(attendance._id, user._id), {
    onSuccess: () => {
      setLoading(false);
      setShowModal(false);
      setToast({
        status: 'ok',
        msg: 'Attendance cancelled',
        show: true
      });
      if (cancelType === 'singleClass') {
        delayFetchFunctions(['singleClass']);
      } else {
        delayFetchFunctions([
          ['upcomingClasses', selectedClass.__t],
          ['clientUpcomingClasses', selectedClass.__t],
          ['userData']
        ]);
      }
    },
    onError: (response) => {
      setLoading(false);
      setShowModal(false);
      setToast({
        status: 'critical',
        msg: response.data.message ? response.data.message : 'Something went wrong, try again',
        show: true
      });
    }
  });

  const mutateCancelClass = useMutation(
    ({ shouldAdminChargeClients }) => cancelClass(selectedClass._id, shouldAdminChargeClients),
    {
      onSuccess: () => {
        setShowModal(false);
        setToast({
          status: 'ok',
          msg: 'Successfully cancelled',
          show: true
        });
        if (cancelType === 'singleClass') {
          delayFetchFunctions(['singleClass']);
        } else {
          delayFetchFunctions([['upcomingClasses', selectedClass.__t]]);
        }
      },
      onError: (err) => {
        setShowModal(false);
        setShowModal(false);
        setToast({
          status: 'critical',
          msg: returnErrorFromResponse(err),
          show: true
        });
      }
    }
  );

  if (!selectedClass.active) {
    return null;
  }

  const returnProperButton = (type) => {
    switch (type) {
      case 'cancelAttendanceButton':
        return (
          <Button
            style={{
              width: '100%',
              height: '40px',
              backgroundColor: '#414142',
              fontWeight: '700',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
            box
            label="Cancel"
            secondary
            onClick={() => setShowModal(true)}
            data-cy="cancelBtn"
          />
        );

      case 'cancelAttendanceXicon':
        return <Close style={{ cursor: 'pointer', margin: '0px' }} onClick={() => setShowModal(true)} />;

      case 'cancelClassXicon':
        return <Close style={{ cursor: 'pointer', margin: '0px' }} onClick={() => setShowModal(true)} />;

      case 'cancelClassButton':
        return <Button label="Cancel" secondary onClick={() => setShowModal(true)} data-cy="cancelBtn" />;

      default:
        return null;
    }
  };

  return (
    <div className={classes.root}>
      <CustomToast toast={toast} />
      <Modal onRequestClose={() => setShowModal(false)} isOpen={showModal} className="ss-modal">
        <div>{cancelClassDetails.message}</div>
        <div className="ss-modal__buttons-container">
          {loading ? (
            <Spinning />
          ) : (
            <>
              <Button
                box
                label="Yes"
                secondary
                onClick={() =>
                  type === 'cancelAttendanceButton' || type === 'cancelAttendanceXicon'
                    ? mutateCancelAttendance.mutate()
                    : mutateCancelClass.mutate({ shouldAdminChargeClients: cancelClassDetails.checkTiming })
                }
                style={cancelClassDetails.checkTiming ? { width: '100px' } : {}}
              />
              {cancelClassDetails.checkTiming && (
                <Button
                  box
                  label="No"
                  secondary
                  onClick={() =>
                    type === 'cancelAttendanceButton' || type === 'cancelAttendanceXicon'
                      ? mutateCancelAttendance.mutate()
                      : mutateCancelClass.mutate({ shouldAdminChargeClients: false })
                  }
                  style={cancelClassDetails.checkTiming ? { width: '100px' } : {}}
                />
              )}
            </>
          )}
          <Button
            box
            label="Cancel"
            primary={!cancelClassDetails.checkTiming}
            onClick={() => setShowModal(false)}
            style={cancelClassDetails.checkTiming ? { width: '150px' } : {}}
          />
        </div>
      </Modal>

      {returnProperButton(type)}
    </div>
  );
};

export default withRouter(withUser(CancelAttendanceOrClass));
